<template>
  <div class="promotionAudit">
    <el-dialog title="推广审核"
               :visible.sync="promotion_dialog"
               width="30%">
      <el-form :model="auditData"
               ref="auditData">
        <el-form-item label="选择审核状态:"
                      prop="zt"
                      :rules="[
      { required: true, message: '审核状态不能为空',trigger: 'change'},
    ]">
          <el-select v-model="auditData.zt"
                     placeholder="请选择状态">
            <el-option v-for="item in withdrawal_audit_status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="输入审核备注:"
                      prop="jionbak"
                      :rules="[
      { required: true, message: '审核备注不能为空'},
    ]">
          <el-input v-model="auditData.jionbak"
                    placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancelUserAudit()">取 消</el-button>
        <el-button type="primary"
                   @click="detectionPromotion('auditData')">确 定</el-button>
      </span>
    </el-dialog>
    <div class="promotionAudit_top">
      <div class="topItem">
        <div class="item_title">状态</div>
        <div class="item_content">
          <el-select v-model="inquire.status"
                     @change='inquireData'
                     size="mini"
                     placeholder="请选择状态">
            <el-option v-for="item in statusList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="topItem">
        <div class="item_title">手机号</div>
        <div class="item_content">
          <el-input v-model="inquire.mobile"
                    size="mini"
                    @keyup.enter.native="inquireData"
                    placeholder="输入手机号回车查询"></el-input>
        </div>
      </div>

      <div class="topItem">
        <div class="item_title">用户名</div>
        <div class="item_content">
          <el-input v-model="inquire.username"
                    size="mini"
                    @keyup.enter.native="inquireData"
                    placeholder="输入用户名回车查询"></el-input>
        </div>
      </div>

      <div class="topItem"
           style="width: 400px;">
        <div class="item_title">时间段</div>
        <div class="item_content">
          <el-date-picker v-model="dataArr"
                          size="mini"
                          @change='selectTime'
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </div>
      </div>

      <div class="topItem">
        <div>
          <el-button size='medium'
                     type="primary"
                     @click="inquireData">查询</el-button>
          <el-button size='medium'
                     type="warning"
                     @click="resetData">重置</el-button>
        </div>
      </div>

    </div>

    <div class="promotionAuditm_table">
      <el-table :data="tableData"
                v-loading="loading"
                style="width: 100%"
                height="100%">
        <el-table-column label="状态"
                         width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status==0?'warning':scope.row.status==1?'success':scope.row.status==-1?'danger':'info'">{{scope.row.status==0?'待审核':scope.row.status==1?'已审核':scope.row.status==-1?'拒绝申请':'异常'}}</el-tag>

          </template>
        </el-table-column>
        <el-table-column label="申请时间"
                         width="180">
          <template slot-scope="scope">
            <span>{{common.formatDate(scope.row.createtime)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请用户"
                         width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.username">{{scope.row.username}}</span>
            <span v-else
                  class="color:#999">未填写</span>
          </template>
        </el-table-column>
        <el-table-column label="申请备注"
                         width="180">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        transition='el-zoom-in-bottom'
                        placement="top-start">
              <div slot="content"
                   v-html="scope.row.bakinfo"></div>
              <span class="rowOne">{{ scope.row.bakinfo}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="name"
                         label="审核时间"
                         width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.createtime!=0">{{common.formatDate(scope.row.createtime)}}
            </span>
            <span v-else
                  style='color:#999'>未审核</span>
          </template>
        </el-table-column>

        <el-table-column prop="name"
                         label="审核备注"
                         width="180">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        transition='el-zoom-in-bottom'
                        placement="top-start">
              <div slot="content"
                   v-if="scope.row.admininfo"
                   v-html="scope.row.admininfo"></div>
              <span class="rowOne">{{ scope.row.admininfo}}</span>
            </el-tooltip>
            <span v-if="!scope.row.admininfo"
                  style='color:#999'>未审核</span>
          </template>
        </el-table-column>

        <el-table-column label=""
                         align="right">
          <template slot-scope="scope">
            <div>
              <el-button type="primary"
                         v-if="scope.row.status!=1"
                         size="mini"
                         @click="show_audit_dialog(scope.row)">审核</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="promotionAuditm_bottom">
      <el-pagination background
                     layout="prev, pager, next"
                     :page-size='pageSize'
                     :total="totalSize">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { apiPromotionAudit } from '@/request/api'
import common from '@/assets/js/common'
export default {
  name: 'promotionAudit',
  data () {
    return {
      loading: 'false',
      // ------------选择审核状态------------
      withdrawal_audit_status: [{
        value: '1',
        label: '已审核'
      }, {
        value: '0',
        label: '待审核'
      }, {
        value: '-1',
        label: '拒绝申请'
      }],
      // ------------当前审核的用户数据------------
      auditData: {
        id: '',
        zt: '',
        jionbak: ''
      },
      // ---------是否显示推广审核---------
      promotion_dialog: false,
      // ---------公共方法---------
      common,
      // ---------推广数组---------
      tableData: [],
      // ---------时间数组---------
      dataArr: [],
      // ---------状态数组---------
      statusList: [
        {
          label: '已审核',
          value: 1
        },
        {
          label: '待审核',
          value: 0
        }, {
          label: '拒绝申请',
          value: - 1
        }
      ],
      // ---------查询条件---------
      inquire: {
        status: '',
        mobille: '',
        username: '',
        zdtime: {
          start: '',
          end: ''
        }
      },
      // ---------一页显示内容---------
      pageSize: 10,
      // ---------当前显示页---------
      page: 1,
      // ---------总页数---------
      totalSize: 0
    }
  },
  methods: {
    // -------------重置-------------
    resetData () {
      this.inquire = {
        status: '',
        mobille: '',
        username: '',
        zdtime: {
          start: '',
          end: ''
        }
      }
      this.getBillList()

    },
    // -------------查询-------------
    inquireData () {
      this.page = 1
      this.getBillList()
    },
    // -------------确认用户推广审核-------------
    selectTime (e) {
      this.page = 1
      if (e) {
        this.inquire.zdtime.start = e[0]
        this.inquire.zdtime.end = e[1]
      } else {
        this.inquire.zdtime.start = ''
        this.inquire.zdtime.end = ''
      }
      this.inquireData()

    },
    // -------------确认用户推广审核-------------
    async auditPromotion () {
      let res = await apiPromotionAudit({
        pd: 'jion',
        jionbak: this.auditData.jionbak,
        zt: this.auditData.zt,
        id: this.auditData.id
      })
      if (res.errno == 0) {
        this.$message.success(res.message)
        this.promotion_dialog = false
        this.getBillList()
      } else {
        this.$message.error(res.message)
      }
    },
    //展开审核
    show_audit_dialog (row) {
      this.promotion_dialog = true
      this.auditData.id = row.id
    },
    // -------------检测推广申请审核是否填写完成-------------
    detectionPromotion (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.auditPromotion()
        } else {
          return false;
        }
      })
    },
    // -------------取消用户推广审核-------------
    cancelUserAudit () {
      this.promotion_dialog = false
      this.auditData = {
        id: '',
        zt: '',
        jionbak: ''
      }
    },
    // ---------获取申请---------
    async getBillList () {
      this.loading = true
      let res = await apiPromotionAudit({
        pd: 'getlist',
        type: 'mc',
        pageSize: this.pageSize,
        page: this.page,
        status: this.inquire.status !== '' ? this.inquire.status : '',
        mobile: this.inquire.mobile || '',
        username: this.inquire.username || '',
        zdtime: this.inquire.zdtime.start != '' && this.inquire.zdtime.end != '' ? JSON.stringify(this.inquire.zdtime) : ''
      })
      if (res.totalNum == 0) {
        this.$message.error('数据为空')
      } else {
        this.$message.success('获取成功')
      }
      this.totalSize = parseInt(res.totalNum, 10)
      this.tableData = res.txlist
      this.loading = false

    }

  },
  created () {
    this.getBillList()
  }
}
</script>

<style lang='scss'>
.promotionAudit {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  align-items: center;
  box-sizing: border-box;
  .promotionAudit_top,
  .promotionAuditm_table,
  .promotionAuditm_bottom {
    border-radius: 4px;
    margin-bottom: 5px;
    flex: 1;
    background-color: #fff;
    width: 95%;
    overflow: hidden;
  }
  .rowOne {
    display: inline-block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .promotionAudit_top {
    max-height: 80px;
    display: flex;
    .topItem {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .item_title {
        font-size: 14px;
        color: #333;
      }
    }
  }
  .promotionAuditm_bottom {
    max-height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>